<template>
<div></div>
</template>

<script>
export default {
name: "FooterMenu"
}
</script>

<style scoped>

</style>